// Quantity stepper for option cards. Moved verbatim from ServicePanel.tsx
// (zero behaviour change) so every booking panel renders the same control.

export function Stepper({
  value,
  onChange,
  min = 1,
  max = 20,
  retainFocusAtLimit = false,
  ariaLabel = "Quantity",
}: {
  value: number;
  onChange: (n: number) => void;
  /** Lower bound on the "−" button: an option's fewest guests per booking
   *  (units[].party_size_min). At a floor above 1 "−" is disabled the same
   *  way "+" is at the ceiling. Default 1 keeps every other stepper as it was. */
  min?: number;
  // Upper bound on the "+" button. Accommodation passes the room type's
  // inventory_count so a guest can't step past the rooms that actually exist.
  max?: number;
  retainFocusAtLimit?: boolean;
  /** The group's accessible name — "Players" reads better than "Quantity" for a headcount. */
  ariaLabel?: string;
}) {
  const floor = Math.max(1, Math.floor(min));
  const ceiling = Math.max(floor, max);
  const atFloor = floor > 1 && value <= floor;
  return (
    <div className="vt-stepper" role="group" aria-label={ariaLabel}>
      <button type="button" onClick={() => { if (!atFloor) onChange(Math.max(floor, value - 1)); }} aria-label="Decrease" disabled={!retainFocusAtLimit && atFloor} aria-disabled={retainFocusAtLimit && atFloor ? true : undefined}>−</button>
      <span className="vt-stepper-val">{value}</span>
      <button type="button" onClick={() => { if (value < ceiling) onChange(Math.min(ceiling, value + 1)); }} aria-label="Increase" disabled={!retainFocusAtLimit && value >= ceiling} aria-disabled={retainFocusAtLimit && value >= ceiling ? true : undefined}>+</button>
    </div>
  );
}
